import {
  COMPANY_FUTURE_ANCHOR,
  DIVIDEND_PAYOUT_CURRENT,
  DIVIDEND_PAYOUT_FUTURE,
  DIVIDEND_YIELD,
  FUTURE_EARNINGS,
  HEALTH_CASH_RUNWAY,
  HEALTH_DEBT_HISTORY,
  PAST_EARNINGS_REVENUE,
} from '@/constants/anchors';

export const REWARDS = [
  'IsGoodValue',
  'IsGrowingProfitOrRevenue',
  'HasBeenGrowingProfitOrRevenue',
  'IsDividendAttractive',
  'IsGoodRelativeValue',
  'IsTradingBelowAnalystPriceTargets',
];

export const RISKS = [
  'IsAbleToAchieveProfitability',
  'AreRevenueAndEarningsExpectedToGrow',
  'IsInAGoodFinancialPosition',
  'IsDividendSustainable',
  'HasStableSharePriceOverPast3Months',
  'HasNoConcerningRecentEvents',
  'HasSufficientFinancialData',
  'HasHighQualityEarnings',
  'HasNetProfitMarginImprovedOverPastYear',
  'HasMeaningfulRevenue',
  'HasNoSubstantialInsiderSellingOverPastQuarter',
  'HasNotDilutedOverPastYear',
  'HasMeaningfulMarketCap',
  'HasNoNegativeEquity',
];

export const future = {
  fragment: COMPANY_FUTURE_ANCHOR,
  sectionName: 'Section 4.0',
};

export const futureEarnings = {
  fragment: FUTURE_EARNINGS,
  sectionName: 'Section 4.1',
};

export const pastEarningsRevenue = {
  fragment: PAST_EARNINGS_REVENUE,
  sectionName: 'Section 5.1',
};

export const healthDebt = {
  fragment: HEALTH_DEBT_HISTORY,
  sectionName: 'Section 6.2',
};

export const healthCashRunway = {
  fragment: HEALTH_CASH_RUNWAY,
  sectionName: 'Section 6.4',
};

export const dividendYield = {
  fragment: DIVIDEND_YIELD,
  sectionName: 'Section 7.2',
};

export const dividendPayout = {
  fragment: DIVIDEND_PAYOUT_CURRENT,
  sectionName: 'Section 7.3',
};

export const dividendPayoutFuture = {
  fragment: DIVIDEND_PAYOUT_FUTURE,
  sectionName: 'Section 7.4',
};

export const riskFragments = {
  IsAbleToAchieveProfitability: {
    OUTCOME_TRUE_BECOME_NEXT: futureEarnings,
    OUTCOME_FALSE_BECOME_NEXT: futureEarnings,
    OUTCOME_TRUE: pastEarningsRevenue,
    OUTCOME_TRUE_LONG_TERM: pastEarningsRevenue,
    OUTCOME_TRUE_REDUCE_LOSS: pastEarningsRevenue,
    OUTCOME_FALSE_REDUCE_LOSS: pastEarningsRevenue,
  },
  AreRevenueAndEarningsExpectedToGrow: {
    OUTCOME_TRUE_FUTURE: futureEarnings,
    OUTCOME_FALSE_MAJOR_RISK_FUTURE: futureEarnings,
    OUTCOME_TRUE_PAST: pastEarningsRevenue,
    OUTCOME_FALSE_MAJOR_RISK_PAST: pastEarningsRevenue,
  },
  IsInAGoodFinancialPosition: {
    OUTCOME_TRUE_NO_DEBT: healthDebt,
    OUTCOME_TRUE_LOW_DEBT: healthDebt,
    OUTCOME_FALSE_INTEREST: healthDebt,
    OUTCOME_FALSE_CASH_DEBT: healthDebt,
    OUTCOME_FALSE_HIGH_DEBT: healthDebt,
    OUTCOME_TRUE_CASH_RUNWAY: healthCashRunway,
    OUTCOME_FALSE_CASH_RUNWAY_MAJOR: healthCashRunway,
    OUTCOME_FALSE_CASH_RUNWAY_MINOR: healthCashRunway,
  },
  IsDividendSustainable: {
    OUTCOME_TRUE: dividendYield,
    OUTCOME_FALSE_UNSTABLE: dividendYield,
    OUTCOME_FALSE_MAJOR_RISK: dividendPayout,
    OUTCOME_FALSE_MINOR_RISK: dividendPayout,
    OUTCOME_FALSE_MINOR_RISK_EARNINGS: dividendPayout,
    OUTCOME_FALSE_MINOR_RISK_CASH_FLOW: dividendPayoutFuture,
  },
  HasSufficientFinancialData: {
    OUTCOME_TRUE_ANALYSTS: future,
  },
};
